import React from 'react';
import {Button, ControlLabel, Form, FormControl, FormGroup, Glyphicon} from 'react-bootstrap';
import './Login.css';
import {Auth} from 'aws-amplify';
import {Redirect, withRouter} from 'react-router';
import ErrorComponent from '../ErrorComponent';
import {Link} from 'react-router-dom';

class Login extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: false,
      isLoading: false,
      loggingIn: false,
    };
  }

  validateForm = () => {
    return this.state.email.length > 0 && this.state.password.length > 0;
  };

  handleChange = event => {
    this.setState({[event.target.id]: event.target.value});
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ loggingIn: true });

    Auth.signIn(this.state.email, this.state.password)
      .then(user => {
        this.props.auth.setUser(user);
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.props.history.push({ pathname: '/force-password', state: { user: user.username } });
        } else {
          this.props.auth.authenticate();
        }
      })
      .catch(err => {
        if (err.code === 'UserNotConfirmedException') {
          this.props.history.push('/verify');
        } else {
          err.msg = err.message;
          this.setState({ error: [err] });
        }
        this.setState({ loggingIn: false });
      });
  };


  render() {
    if (this.props.auth.isAuthenticated) {
      return <Redirect to='/'/>;
    }

    return (
      <div>
        { this.state.error &&
        <ErrorComponent error={this.state.error}/>
        }
        <Form onSubmit={this.handleSubmit} className="max-width">
          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>Email:</ControlLabel>
            <FormControl
              data-cy="login-email"
              autoFocus={true}
              type="email"
              value={this.state.email}
              onChange={this.handleChange}/>
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>Password:</ControlLabel>
            <FormControl
              data-cy="login-password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange}/>
          </FormGroup>
          <Button
            data-cy="login-button"
            block
            bsSize="large"
            disabled={!this.validateForm() || this.state.loggingIn}
            type="submit">
            { this.state.loggingIn ? 'Loading...  ' : 'Login' }
            { this.state.loggingIn && <Glyphicon glyph="refresh" className="spinning" /> }
          </Button>
          <Link to={'/forgot'}><p style={{ marginTop: '3px' }}>Forgot Password?</p></Link>
        </Form>
      </div>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/user/Login.js